import React from 'react'
import { Link } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'

import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import Divider from '@material-ui/core/Divider'

import MoreVertIcon from '@material-ui/icons/MoreVert'
import EventIcon from '@material-ui/icons/Event'
import AddCircleIcon from '@material-ui/icons/AddCircle'

import { getBreakpointsEnable, makePath } from '../../../lib'
import { Word } from '../../../containers';
import { WID } from '../../../constants/Language';
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'

const styles1 = {
}

const EventMenuItems = withStyles(styles1, { withTheme: true })((props) => {
  const { user, divider } = props

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const handleClick = (name) => (event) => {
    if (props.onClose) {
      props.onClose()
    }
    window.scrollTo(0, 0)
  }

  return (
    <React.Fragment>
      <MenuItem component={Link} to={makePath('/event', language)} onClick={handleClick('home')}>
        <ListItemIcon>
          <EventIcon/>
        </ListItemIcon>
        <ListItemText inset primary={<Word wid={WID.EVENT_MENU.HOME}/>} />
      </MenuItem>
      {divider && (
        <Divider/>
      )}
      {user && (
        <MenuItem component={Link} to={makePath('/event/register', language)} onClick={handleClick('register')}>
          <ListItemIcon>
            <AddCircleIcon/>
          </ListItemIcon>
          <ListItemText inset primary={<Word wid={WID.EVENT_MENU.REGISTER}/>} />
        </MenuItem>
      )}
    </React.Fragment>
  )
})

const styles2 = {
}

class EventMenu extends React.Component {
  state = {
    anchorEl: null,
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { theme, user, width, language } = this.props
    const { anchorEl } = this.state
    const { md } = getBreakpointsEnable(theme, width)
    if (md === false) {
      return (
        <div>
          <IconButton onClick={this.handleOpen} color='inherit'>
            <MoreVertIcon/>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <EventMenuItems user={user} onClose={this.handleClose} language={language}/>
          </Menu>
        </div>
      )
    }
    else {
      return (<div></div>)
    }
  }
}

EventMenu = withStyles(styles2, { withTheme: true })(EventMenu)

export { EventMenuItems, EventMenu }


// WEBPACK FOOTER //
// ./src/Pages/Event/components/EventMenu.js